/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmResponsesList } from "../../funcs/llmResponsesList.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListResponsesRequest$inboundSchema,
};

export const tool$llmResponsesList: ToolDefinition<typeof args> = {
  name: "llm-responses-list",
  description: `List all responses with pagination

Retrieves a paginated list of all agent responses for the authenticated user.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmResponsesList(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
